import React, { useEffect } from "react";
import { connect  } from "react-redux";
import { Card } from "antd";
import { Briefcase, Pen, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getMyJobApplicantList } from "../../../../redux/jobapplicant/jobApplicantState";
import JobPostCard from "../../../public/job-posts/components/JobPostCard";

const MyApplicationsPanel = ({recordList}) => {
  const navigate = useNavigate();

  return (
      <Card>
        <div className="p-5 space-y-8">
          {recordList.length > 0 ? 
          recordList?.map((jobApplication) => (
              <div className="relative group gradient-effect space-y-4">
                <div className="hover-effect group-hover:opacity-30 transition-opacity duration-300" />
                  <JobPostCard
                      key={jobApplication.jap_id}                     
                      recordData={jobApplication.job_post}
                      application={jobApplication}
                  />
              </div>

          ))
          : 
          <div className="flex flex-col items-center justify-center text-center space-y-8">
            <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto">
              <Briefcase className="w-8 h-8 text-gray-400"/>
            </div>
            <h2 className="text-gray-800 text-lg font-medium">
              No Applications Yet
            </h2>
            <p className="text-base">You haven't applied to any positions yet. Browse our open roles and apply to get started!</p>
            <button 
              className="btn-gradient-emerald px-3 py-1.5 flex rounded-lg w-full"
              onClick={() => navigate("/job-posts")}>
              Browse Jobs
            </button>
          </div>
        }
        </div>
      </Card>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.jobApplicant.jobApplicantList?.items,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(MyApplicationsPanel);